import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { GlobalizeService } from './globalize.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private globalize: GlobalizeService
    ) {}

    ngOnInit() {}

    ngAfterContentChecked() {
        this.changeDetectorRef.detectChanges();
        this.globalize.initialize();
    }

    // ngAfterViewInit(): void {
    //     this.changeDetectorRef.detectChanges();
    // }

    ngAfterViewChecked(){ this.changeDetectorRef.detectChanges(); }
}
